<template>
  <div>
    <l-map
      ref="map"
      style="height: 100%; width: 100%"
      :zoom="zoom"
      :center="center"
      :min-zoom="minZoom"
      :max-zoom="maxZoom"
      :options="mapOptions"
      @leaflet:load="mapLoaded"
      @update:zoom="zoomUpdated"
      @update:center="centerUpdated"
      @update:bounds="boundsUpdated">
      <l-tile-layer :url="url"></l-tile-layer>
      <l-control position="bottomleft">
        <div class="flex flex-col lg:flex-row relative items-start lg:items-end">
          <AreaFilter :areaLevel="areaLevel" :isShowDistrict="isShowDistrict" :isShowZone="isShowZone" :showDistrictsLayer="showDistrictsLayer" :showZoneLayer="showZoneLayer" />
          <SchoolFilter :areaLevel="areaLevel"
            :showAllNegeri="showAllNegeri" :updateNegeriAllStatus="updateNegeriAllStatus" :isShowAllNegeri="isShowAllNegeri" :isShowSDNegeri="isShowSDNegeri" :isShowSMPNegeri="isShowSMPNegeri" :isShowSMANegeri="isShowSMANegeri" :isShowSMKNegeri="isShowSMKNegeri" :isShowPKBMNegeri="isShowPKBMNegeri" :isShowOthersNegeri="isShowOthersNegeri"
            :showAllSwasta="showAllSwasta" :updateSwastaAllStatus="updateSwastaAllStatus" :isShowAllSwasta="isShowAllSwasta" :isShowSDSwasta="isShowSDSwasta" :isShowSMPSwasta="isShowSMPSwasta" :isShowSMASwasta="isShowSMASwasta" :isShowSMKSwasta="isShowSMKSwasta" :isShowPKBMSwasta="isShowPKBMSwasta" :isShowOthersSwasta="isShowOthersSwasta" />
          <MutationFilter :areaLevel="areaLevel" :isShowOneZone="isShowOneZone" :isShowCrossZone="isShowCrossZone" :toggleShowOneZone="toggleShowOneZone" :toggleShowCrossZone="toggleShowCrossZone" />
          <Legends :areaLevel="areaLevel" />
        </div>
      </l-control>
      <l-control position="topleft">
        <div class="flex">
          <div class="pr-1">
            <Search :isSearching="isSearching" :search="search" :isSearchResultAvailable="isSearchResultAvailable" :searchResults="searchResults" :resultSelected="openSchool" />
          </div>
          <div class="pl-1">
            <LevelButton :areaLevel="areaLevel" :showProvinces="showProvinces" :showDistricts="showDistricts" />
          </div>
        </div>
      </l-control>
      <l-layer-group ref="circle" v-if="areaLevel === 'school' && isShowSelectedCircle">
        <l-circle-marker :lat-lng="selectedCircle.center" :radius="selectedCircle.radius" :color="selectedCircle.color" />
      </l-layer-group>
      <l-layer-group ref="polylines" v-if="areaLevel === 'zone' || areaLevel === 'school'">
        <v-polyline-decorator v-for="(polyline, index) in filteredPolylines" :key="'arrow-' + index" :paths="[polyline.latlngs]" :patterns="polyline.patterns"></v-polyline-decorator>
        <l-polyline v-for="(polyline, index) in filteredPolylines" :key="index" :lat-lngs="polyline.latlngs" :color="polyline.color"></l-polyline>
      </l-layer-group>
      <l-feature-group ref="schools" :visible="areaLevel === 'school'">
        <l-geo-json v-for="(geojson, index) in filteredSchools" :geojson="geojson" :options="geoJsonOptionsSchool" :key="index"></l-geo-json>
      </l-feature-group>
      <l-feature-group ref="zones" :visible="!isDistrictOnly && (areaLevel === 'zone' || areaLevel === 'district' || areaLevel === 'school')">
        <l-geo-json v-for="(geojson, index) in zones" :geojson="geojson" :options="geoJsonOptionsZone" :key="index"></l-geo-json>
      </l-feature-group>
      <l-feature-group ref="districts" :visible="!isZoneOnly && (areaLevel === 'district' || areaLevel === 'zone' || areaLevel === 'school')">
        <l-geo-json v-for="(geojson, index) in districts" :geojson="geojson" :options="geoJsonOptionsDistrict" :key="index"></l-geo-json>
      </l-feature-group>
      <l-feature-group ref="provinces" :visible="areaLevel === 'province'">
        <l-geo-json v-for="(geojson, index) in provinces" :geojson="geojson" :options="geoJsonOptionsProvince" :key="index"></l-geo-json>
      </l-feature-group>
    </l-map>
    <ModalProvince v-if="showModalProvince" :showProvinceArea="showProvinceArea" />
    <ModalDistrict v-if="showModalDistrict" />
    <ModalZone v-if="showModalZone" :showZoneArea="showZoneArea" />
    <ModalSchool v-if="showModalSchool" :onTeacherClicked="onTeacherClicked" :onCourseSelected="onCourseSelected" />
    <ModalMutation v-if="showModalMutation" :onTeacherClicked="onTeacherClicked" />
    <ModalMutations v-if="showModalMutations" />
    <ModalRecapSchool v-if="showModalRecapSchool" />
    <ModalRecapDistrict v-if="showModalRecapDistrict" />
    <ModalAbout v-if="showModalAbout" />
    <ModalProfile v-if="showModalProfile" />
    <Notification v-if="showNotification" :message="notification" />
  </div>
</template>

<script>
import {
  LMap,
  LTileLayer,
  LGeoJson,
  LFeatureGroup,
  LLayerGroup,
  LPolyline,
  LCircleMarker,
  LControl
} from 'vue2-leaflet'
import Vue2LeafletPolylineDecorator from 'vue2-leaflet-polylinedecorator'
import ModalProvince from '@/components/ModalProvince'
import ModalDistrict from '@/components/ModalDistrict'
import ModalZone from '@/components/ModalZone'
import ModalSchool from '@/components/ModalSchool'
import ModalMutation from '@/components/ModalMutation'
import ModalRecapSchool from '@/components/ModalRecapSchool'
import ModalRecapDistrict from '@/components/ModalRecapDistrict'
import ModalMutations from '@/components/ModalMutations'
import ModalAbout from '@/components/ModalAbout'
import ModalProfile from '@/components/ModalProfile'
import Notification from '@/components/Notification'
import Search from '@/components/Search'
import LevelButton from '@/components/LevelButton'
import Legends from '@/components/Legends'
import AreaFilter from '@/components/AreaFilter'
import SchoolFilter from '@/components/SchoolFilter'
import MutationFilter from '@/components/MutationFilter'
import oboe from 'oboe'
import { mapState } from 'vuex'
import {
  UPDATE_STATUS,
  UPDATE_MOBILE_LOADING,
  CHANGE_AREA_LEVEL,
  CHANGE_SELECTED_PROVINCE,
  CHANGE_SELECTED_DISTRICT,
  CHANGE_SELECTED_ZONE,
  CHANGE_SELECTED_SCHOOL,
  CHANGE_MUTATION_INFO,
  TOGGLE_MODAL_PROVINCE,
  TOGGLE_MODAL_DISTRICT,
  TOGGLE_MODAL_ZONE,
  TOGGLE_MODAL_SCHOOL,
  TOGGLE_MODAL_MUTATION
} from '@/mutationTypes'

const INITIAL_CENTER = [-2.6000285, 118.015776]

export default {
  name: 'home',
  components: {
    LMap,
    LTileLayer,
    LFeatureGroup,
    LLayerGroup,
    LPolyline,
    'v-polyline-decorator': Vue2LeafletPolylineDecorator,
    LCircleMarker,
    LControl,
    LGeoJson,
    ModalProvince,
    ModalDistrict,
    ModalZone,
    ModalSchool,
    ModalMutation,
    ModalRecapSchool,
    ModalRecapDistrict,
    ModalMutations,
    ModalAbout,
    ModalProfile,
    Notification,
    Search,
    LevelButton,
    AreaFilter,
    SchoolFilter,
    MutationFilter,
    Legends
  },
  computed: {
    ...mapState([
      'user',
      'selectedProvince',
      'selectedDistrict',
      'selectedZone',
      'selectedSchool',
      'selectedTeacher',
      'selectedCourse',
      'showModalProvince',
      'showModalDistrict',
      'showModalZone',
      'showModalSchool',
      'showModalMutation',
      'showModalRecapSchool',
      'showModalRecapDistrict',
      'showModalMutations',
      'showModalAbout',
      'showModalProfile',
      'status',
      'areaLevel',
      'mutationInfo'
    ]),
    featureCollection () {
      return {
        type: 'FeatureCollection',
        features: this.features
      }
    },
    isDistrictOnly () {
      return this.isShowDistrict && !this.isShowZone
    },
    isZoneOnly () {
      return this.isShowZone && !this.isShowDistrict
    },
    filteredSchools () {
      let levels = ['SD', 'SMP', 'SMA', 'SMK', 'PKBM']
      return this.schools.filter((school) => {
        let type
        if (school.properties.status === 'N') {
          type = 'Negeri'
        } else if (school.properties.status === 'S') {
          type = 'Swasta'
        }
        let status = false
        levels.forEach((level) => {
          if (school.properties.bentuk === level && this['isShow' + level + type]) {
            status = true
          }
        })
        return status
      })
    },
    filteredPolylines () {
      return this.polylines.filter((polyline) => {
        if (polyline.type === 'one-zone' && this.isShowOneZone) {
          return true
        }
        if (polyline.type === 'cross-level' && this.isShowCrossLevel) {
          return true
        }
        if (polyline.type === 'cross-zone' && this.isShowCrossZone) {
          return true
        }
        return false
      })
    }
  },
  data () {
    return {
      map: null,
      url: 'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
      zoom: 5,
      minZoom: 5,
      maxZoom: 7,
      center: INITIAL_CENTER,
      mapOptions: {
        zoomControl: false
      },
      geoJsonOptionsProvince: {
        color: '#221d13',
        fillOpacity: 0.05,
        weight: 2,
        onEachFeature: this.onEachFeatureProvince
      },
      geoJsonOptionsDistrict: {
        color: '#221d13',
        fillOpacity: 0.05,
        weight: 2,
        onEachFeature: this.onEachFeatureDistrict
      },
      geoJsonOptionsZone: {
        color: '#38c172',
        fillOpacity: 0.1,
        weight: 2,
        onEachFeature: this.onEachFeatureZone
      },
      geoJsonOptionsSchool: {
        color: '#3f1bff',
        fillOpacity: 0.2,
        weight: 2,
        onEachFeature: this.onEachFeatureSchool,
        pointToLayer: this.schoolPoint
      },
      bounds: null,
      googleMapsApiKey: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
      provinces: [],
      districts: [],
      zones: [],
      selectedZoneLayer: null,
      schools: [],
      // districtLayers: [],
      schoolLayers: [],
      polylines: [],
      // patterns: [{
      //   offset: '100%',
      //   repeat: 0,
      //   symbol: window.L.Symbol.arrowHead({
      //     pixelSize: 15,
      //     polygon: false,
      //     pathOptions: {
      //       stroke: true
      //     }
      //   })
      // }],
      isShowAllNegeri: true,
      isShowSDNegeri: true,
      isShowSMPNegeri: true,
      isShowSMANegeri: true,
      isShowSMKNegeri: true,
      isShowPKBMNegeri: true,
      isShowOthersNegeri: true,
      isShowAllSwasta: false,
      isShowSDSwasta: false,
      isShowSMPSwasta: false,
      isShowSMASwasta: false,
      isShowSMKSwasta: false,
      isShowPKBMSwasta: false,
      isShowOthersSwasta: false,
      selectedCircle: {
        center: this.center,
        radius: 8,
        color: '#ffffff'
      },
      // circleInterval: null,
      isShowSelectedCircle: false,
      isShowDistrict: false,
      isShowZone: false,
      isShowOneZone: true,
      isShowCrossLevel: false,
      isShowCrossZone: false,
      haveMoreTeacher: false,
      popups: [],
      notification: '',
      showNotification: false,
      isFetchingMovement: false,
      isMovementAvailable: false,
      isSearchResultAvailable: false,
      isSearching: false,
      searchResults: []
    }
  },
  async created () {
    if (this.$route.name === 'public') {
      let zoneCode = this.$route.params.zoneCode
      try {
        let response = await fetch(process.env.VUE_APP_API_URL + '/api/getZoneByCode/' + zoneCode)
        let json = await response.json()
        if (json.status) {
          this.openPublicZone(json.zone)
        }
      } catch (err) {
        // console.log(err)
      }
    }
  },
  mounted () {
    if (this.$store.getters.isLogin) {
      if (this.user.role === 'district') {
        this.onProvinceClicked(this.user.province.properties)
        this.showProvinceArea()
      } else {
        this.showProvinces()
      }
    }
  },
  watch: {
    async '$route' (to, from) {
      if (this.$route.name === 'public') {
        let zoneCode = to.params.zoneCode
        try {
          let response = await fetch(process.env.VUE_APP_API_URL + '/api/getZoneByCode/' + zoneCode)
          let json = await response.json()
          if (json.status) {
            this.openPublicZone(json.zone)
          }
        } catch (err) {
          // console.log(err)
        }
      }
    }
  },
  methods: {
    mapLoaded () {
      this.map = this.$refs.map.mapObject
    },
    zoomUpdated (zoom) {
      this.zoom = zoom
    },
    centerUpdated (center) {
      this.center = center
    },
    boundsUpdated (bounds) {
      this.bounds = bounds
    },
    onEachFeatureProvince (feature, layer) {
      layer.bindTooltip(feature.properties.nama)
      layer.on('mouseover', (e) => {
        layer.setStyle({
          color: '#267bbe',
          fillOpacity: 0.5
        })
      })
      layer.on('mouseout', (e) => {
        layer.setStyle({
          color: '#221d13',
          fillOpacity: 0.05
        })
      })
      layer.on('click', (e) => {
        this.onProvinceClicked(feature.properties)
      })
    },
    onEachFeatureDistrict (feature, layer) {
      layer.bindTooltip(feature.properties.nama_kabkota)
      // this.districtLayers.push(layer)
      layer.on('mouseover', (e) => {
        layer.setStyle({
          color: '#267bbe',
          fillOpacity: 0.5
        })
      })
      layer.on('mouseout', (e) => {
        layer.setStyle({
          color: '#221d13',
          fillOpacity: 0.05
        })
      })
      layer.on('click', (e) => {
        this.onDistrictClicked(feature.properties)
      })
    },
    onEachFeatureZone (feature, layer) {
      // if (this.areaLevel === 'school') {

      // } else {
      layer.bindTooltip(feature.properties.kode_zonasi)
      layer.on('mouseover', (e) => {
        layer.setStyle({
          color: '#38c172',
          fillOpacity: 0.5
        })
      })
      layer.on('mouseout', (e) => {
        layer.setStyle({
          color: '#38c172',
          fillOpacity: 0.1
        })
      })
      layer.on('click', (e) => {
        this.selectedZoneLayer = layer
        this.onZoneClicked(feature.properties)
      })
      // }
    },
    onEachFeatureSchool (feature, layer) {
      // console.log(layer._leaflet_id)
      // layer._leaflet_id = feature.id
      // console.log(layer._leaflet_id)
      // layer.bindPopup(`
      //   <h5>` + feature.properties.nama + `</h5>
      //   <p>` + feature.properties.kabupaten_kota + `</p>
      // `)
      this.schoolLayers.push({
        feature: feature,
        layer: layer
      })
      layer.bindTooltip(feature.properties.nama)
      layer.on('click', (e) => {
        this.updateSelectedCircle(feature.geometry.coordinates[1], feature.geometry.coordinates[0], feature.properties.bentuk)
        this.onSchoolClicked(feature)
      })
    },
    updateSelectedCircle (lat, lng, form) {
      // clearInterval(this.circleInterval)
      let center = [lat, lng]
      let radius = 8
      let color = '#ffffff'
      switch (form) {
        case 'SD':
          radius = 8
          break
        case 'SMP':
          radius = 9
          break
        case 'SMA':
          radius = 10
          break
        case 'SMK':
          radius = 10
          break
        case 'PKBM':
          radius = 10
          break
      }
      this.selectedCircle = {
        center: center,
        radius: radius,
        color: color
      }
      // let delta = 0
      // let direction = 'up'
      // this.circleInterval = setInterval(() => {
      //   if (direction === 'up') {
      //     if (delta < 4) {
      //       delta++
      //     } else {
      //       direction = 'down'
      //     }
      //   } else {
      //     if (delta > 0) {
      //       delta--
      //     } else {
      //       direction = 'up'
      //     }
      //   }
      //   this.selectedCircle.radius = radius + delta
      // }, 150)
      this.isShowSelectedCircle = true
    },
    centerArea (parsedJson, pad) {
      let featureCollection = {
        type: 'FeatureCollection',
        features: parsedJson
      }
      let geojson = window.L.geoJson(featureCollection)
      let bounds = geojson.getBounds()
      this.map.fitBounds(bounds)
      if (pad) {
        this.map.setMaxBounds(bounds.pad(pad))
      }
    },
    toggleModal (modal) {
      this.$store.dispatch(TOGGLE_MODAL_PROVINCE, false)
      this.$store.dispatch(TOGGLE_MODAL_DISTRICT, false)
      this.$store.dispatch(TOGGLE_MODAL_ZONE, false)
      this.$store.dispatch(TOGGLE_MODAL_SCHOOL, false)
      this.$store.dispatch(TOGGLE_MODAL_MUTATION, false)
      if (modal) {
        this.$store.dispatch(modal, true)
      }
    },
    toggleAreaLevel (level) {
      this.$store.dispatch(CHANGE_AREA_LEVEL, level)
    },
    toggleSelection (selection, value) {
      this.$store.dispatch(selection, value)
    },
    fetchAllProvinces () {
      this.provinces.splice(0, this.provinces.length)
      this.$store.dispatch(UPDATE_STATUS, 'Mengambil peta provinsi dari server...')
      this.$store.dispatch(UPDATE_MOBILE_LOADING, true)
      oboe(process.env.VUE_APP_API_URL + '/api/provinces').node('!.[*]', (province) => {
        this.provinces.push(province)
        this.$store.dispatch(UPDATE_STATUS, 'Memuat peta ' + province.properties.nama + '...')
      }).on('done', (parsedJson) => {
        this.$store.dispatch(UPDATE_STATUS, 'Selesai memuat peta provinsi &#x2714;')
        this.$store.dispatch(UPDATE_MOBILE_LOADING, false)
        this.centerArea(parsedJson, 0.8)
      }).on('fail', () => {
        this.$store.dispatch(UPDATE_MOBILE_LOADING, false)
        // console.log('Fail')
      })
    },
    fetchAllDistricts (callback) {
      this.districts.splice(0, this.districts.length)
      this.$store.dispatch(UPDATE_STATUS, 'Mengambil peta kota/kabupaten dari server...')
      this.$store.dispatch(UPDATE_MOBILE_LOADING, true)
      oboe(process.env.VUE_APP_API_URL + '/api/districts/' + this.selectedProvince.kode_wilayah).node('!.[*]', (district) => {
        this.districts.push(district)
        this.$store.dispatch(UPDATE_STATUS, 'Memuat peta ' + district.properties.nama_kabkota + '...')
      }).on('done', (parsedJson) => {
        this.$store.dispatch(UPDATE_STATUS, 'Selesai memuat peta kota/kabupaten &#x2714;')
        this.$store.dispatch(UPDATE_MOBILE_LOADING, false)
        this.centerArea(parsedJson)
        if (callback) callback()
      }).on('fail', () => {
        this.$store.dispatch(UPDATE_MOBILE_LOADING, false)
        // console.log('Fail')
      })
    },
    fetchAllZones (callback) {
      this.zones.splice(0, this.zones.length)
      this.$store.dispatch(UPDATE_STATUS, 'Mengambil peta zona dari server...')
      this.$store.dispatch(UPDATE_MOBILE_LOADING, true)
      oboe(process.env.VUE_APP_API_URL + '/api/zones/' + this.selectedProvince.kode_wilayah).node('!.[*]', (zone) => {
        this.zones.push(zone)
        this.$store.dispatch(UPDATE_STATUS, 'Memuat peta zona ' + zone.properties.kode_zonasi + '...')
      }).on('done', (parsedJson) => {
        this.$store.dispatch(UPDATE_STATUS, 'Selesai memuat peta zona &#x2714;')
        this.$store.dispatch(UPDATE_MOBILE_LOADING, false)
        if (callback) callback()
      }).on('fail', () => {
        this.$store.dispatch(UPDATE_MOBILE_LOADING, false)
        // console.log('Fail')
      })
    },
    fetchAZone (callback) {
      this.zones.splice(0, this.zones.length)
      this.$store.dispatch(UPDATE_STATUS, 'Mengambil peta zona dari server...')
      this.$store.dispatch(UPDATE_MOBILE_LOADING, true)
      oboe(process.env.VUE_APP_API_URL + '/api/zone/' + this.selectedZone.zonasi_id).node('!.[*]', (zone) => {
        this.zones.push(zone)
        this.$store.dispatch(UPDATE_STATUS, 'Memuat peta zona ' + zone.properties.kode_zonasi + '...')
      }).on('done', (parsedJson) => {
        this.$store.dispatch(UPDATE_STATUS, 'Selesai memuat peta zona &#x2714;')
        this.$store.dispatch(UPDATE_MOBILE_LOADING, false)
        if (callback) callback()
      }).on('fail', () => {
        this.$store.dispatch(UPDATE_MOBILE_LOADING, false)
        // console.log('Fail')
      })
    },
    fetchSchools (callback) {
      this.schools.splice(0, this.schools.length)
      this.schoolLayers.splice(0, this.schoolLayers.length)
      this.$store.dispatch(UPDATE_STATUS, 'Mengambil titik sekolah dari server...')
      this.$store.dispatch(UPDATE_MOBILE_LOADING, true)
      oboe(process.env.VUE_APP_API_URL + '/api/schools/' + this.selectedZone.zonasi_id).node('!.[*]', (school) => {
        this.schools.push(school)
        this.$store.dispatch(UPDATE_STATUS, 'Memuat titik sekolah ' + school.properties.nama + '...')
      }).on('done', (parsedJson) => {
        this.$store.dispatch(UPDATE_STATUS, 'Selesai memuat titik sekolah &#x2714;')
        this.$store.dispatch(UPDATE_MOBILE_LOADING, false)
        this.centerArea(parsedJson)
        if (callback) callback()
      }).on('fail', async () => {
        this.$store.dispatch(UPDATE_MOBILE_LOADING, false)
        // console.log('Fail')
      })
    },
    showProvinces () {
      this.maxZoom = 7
      this.toggleModal(false)
      this.toggleAreaLevel('province')
      this.fetchAllProvinces()
    },
    showProvinceArea () {
      this.provinces.splice(0, this.provinces.length)
      this.maxZoom = 11
      this.toggleModal(false)
      this.toggleAreaLevel('zone')
      this.isShowDistrict = true
      this.isShowZone = true
      this.fetchAllDistricts(() => {
        this.fetchAllZones()
      })
    },
    showDistricts () {
      this.polylines.splice(0, this.polylines.length)
      this.removePopups()
      this.maxZoom = 12
      this.toggleModal(false)
      this.toggleAreaLevel('zone')
      this.fetchAllDistricts(() => {
        this.fetchAllZones()
      })
    },
    showDistrictsLayer () {
      this.isShowDistrict = !this.isShowDistrict
      if (this.isShowDistrict) {
        setTimeout(() => {
          this.$refs.zones.mapObject.bringToFront()
        }, 0)
      }
    },
    showZoneLayer () {
      this.isShowZone = !this.isShowZone
    },
    showZoneArea (callback) {
      this.maxZoom = 18
      this.toggleModal(false)
      this.toggleAreaLevel('school')
      this.fetchAZone(() => {
        this.fetchSchools(() => {
          if (callback) callback()
        })
      })
    },
    onProvinceClicked (properties) {
      this.toggleSelection(CHANGE_SELECTED_PROVINCE, properties)
      this.toggleModal(TOGGLE_MODAL_PROVINCE, true)
    },
    onDistrictClicked (properties) {
      this.toggleSelection(CHANGE_SELECTED_DISTRICT, properties)
      this.toggleModal(TOGGLE_MODAL_DISTRICT, true)
    },
    async onZoneClicked (properties) {
      this.toggleSelection(CHANGE_SELECTED_ZONE, properties)
      this.toggleModal(TOGGLE_MODAL_ZONE, true)
    },
    onSchoolClicked (properties, callback) {
      // console.log(properties)
      // // console.log(this.$refs.schools.mapObject._layers)
      // this.$refs.schools.mapObject.eachLayer((layer) => {
      //   console.log('layer', layer.feature)
      // })
      // let skull = this.$refs.schools.mapObject.getLayer(properties.id)
      // console.log(skull)
      this.polylines.splice(0, this.polylines.length)
      this.removePopups()
      this.toggleSelection(CHANGE_SELECTED_SCHOOL, properties)
      this.toggleModal(TOGGLE_MODAL_SCHOOL, true)
      if (callback) callback()
    },
    removePopups (type) {
      if (type) {
        this.popups.filter(popup => {
          return popup.type === type
        }).forEach(popup => {
          this.map.closePopup(popup)
        })
      } else {
        this.popups.forEach(popup => {
          this.map.closePopup(popup)
        })
      }
    },
    onCourseSelected (haveMoreTeacher) {
      this.haveMoreTeacher = haveMoreTeacher
      this.polylines.splice(0, this.polylines.length)
      this.removePopups()
    },
    async onTeacherClicked (teacher, course, checkMoreTeacher = true) {
      if (this.user.role === 'district' && (this.selectedDistrict.kode_wilayah !== this.user.district.properties.kode_wilayah)) {
        return
      }

      if (checkMoreTeacher) {
        if (!this.haveMoreTeacher) {
          return
        }
      }

      this.selectedMutation = {
        teacher: teacher,
        course: course
      }

      this.isShowOneZone = true
      this.removePopups()
      this.updateOneZone()
      this.isShowCrossZone = false
    },
    toggleShowOneZone () {
      this.isShowOneZone = !this.isShowOneZone
      if (this.isShowOneZone) {
        this.updateOneZone()
      } else {
        this.removePopups('one-zone')
      }
    },
    toggleShowCrossZone () {
      this.isShowCrossZone = !this.isShowCrossZone
      if (this.isShowCrossZone) {
        this.updateCrossZone()
      } else {
        this.removePopups('cross-zone')
      }
    },
    async updateOneZone () {
      let teacher = this.selectedMutation.teacher
      let course = this.selectedMutation.course

      let otherPolylines = this.polylines.filter(polyline => {
        return polyline.type === 'cross-zone'
      })
      this.polylines = otherPolylines
      this.$store.dispatch(CHANGE_MUTATION_INFO, null)
      this.$store.dispatch(TOGGLE_MODAL_MUTATION, false)
      this.removePopups('one-zone')

      try {
        this.isFetchingMovement = true
        this.teachers = []
        this.course = ''
        // console.log(course)
        let response = await fetch(process.env.VUE_APP_API_URL + '/api/simrasio/kebutuhanPerMapel/' + this.selectedSchool.properties.bentuk + '/' + this.selectedSchool.properties.sekolah_id + '/' + encodeURI(course))
        this.isFetchingMovement = false
        let json = await response.json()
        if (json.status === 200) {
          this.generatePolylines(json.result, teacher, course, 'one-zone')
        } else {
          this.isMovementAvailable = false
          this.showNoMovementNotification()
        }
      } catch (err) {
        // console.log(err)
        this.isMovementAvailable = false
        this.showNoMovementNotification()
      }
    },
    updateCrossZone () {
      let teacher = this.selectedMutation.teacher
      let course = this.selectedMutation.course

      let otherPolylines = this.polylines.filter(polyline => {
        return polyline.type === 'one-zone'
      })
      this.polylines = otherPolylines
      this.$store.dispatch(CHANGE_MUTATION_INFO, null)
      this.$store.dispatch(TOGGLE_MODAL_MUTATION, false)
      this.removePopups('cross-zone')

      // console.log('eksekusi')

      this.$store.dispatch(UPDATE_STATUS, 'Mengambil titik redistribusi dari server...')
      this.$store.dispatch(UPDATE_MOBILE_LOADING, false)
      oboe(process.env.VUE_APP_API_URL + '/api/simrasio/kebutuhanPerMapelKabKota/' + this.selectedSchool.properties.bentuk + '/' + this.selectedDistrict.kode_wilayah + '/' + encodeURI(course) + '/' + this.selectedZone.zonasi_id).node('!.[*]', (school) => {
        this.generatePolylines([school], teacher, course, 'cross-zone')
        this.$store.dispatch(UPDATE_STATUS, 'Memuat titik redistribusi ' + school.properties.nama + '...')
      }).on('done', (parsedJson) => {
        this.$store.dispatch(UPDATE_STATUS, 'Selesai memuat titik redistribusi &#x2714;')
        this.$store.dispatch(UPDATE_MOBILE_LOADING, false)
        // this.centerArea(parsedJson)
        // if (callback) callback()
      }).on('fail', async () => {
        this.$store.dispatch(UPDATE_MOBILE_LOADING, false)
        // console.log('Fail')
      })
    },
    generatePolylines (result, teacher, course, type) {
      // let inNeeds = result.filter((item) => {
      //   return item.properties.kebutuhan < 0
      // })
      if (result.length) {
        var color, styleColor
        switch (type) {
          case 'one-zone':
            color = '#267bbe'
            styleColor = 'brand'
            break
          case 'cross-level':
            color = '#e2c84e'
            styleColor = 'yellow'
            break
          case 'cross-zone':
            color = '#be262f'
            styleColor = 'red'
            break
        }
        result.forEach((item) => {
          let from = [this.selectedSchool.geometry.coordinates[1], this.selectedSchool.geometry.coordinates[0]]
          let to = [item.geometry.coordinates[1], item.geometry.coordinates[0]]
          let patterns = [{
            offset: '100%',
            repeat: 0,
            symbol: window.L.Symbol.arrowHead({
              pixelSize: 15,
              polygon: false,
              pathOptions: {
                stroke: true,
                color: color
              }
            })
          }]
          let options = {
            latlngs: [from, to],
            color: color,
            type: type,
            patterns: patterns
          }
          this.polylines.push(options)
          let htmlString
          if (this.$store.getters.isLogin) {
            htmlString = `
              <div class="flex flex-col items-center">
                <div class="text-black" style="font-size: 0.6rem;">` + item.properties.nama + `</div>
                <div class="mt-1 text-black" style="font-size: 0.6rem; font-weight: bold;">Kebutuhan: ` + item.properties.kebutuhan + `</div>
                <div class="mutation-button mt-1 bg-` + styleColor + ` hover:bg-` + styleColor + `-dark text-white font-bold py-1 px-2 rounded cursor-pointer" style="font-size: 0.6rem;">Redistribusi</div>
              </div>
            `
          } else {
            htmlString = `
              <div class="flex flex-col items-center">
                <div class="text-black" style="font-size: 0.6rem;">` + item.properties.nama + `</div>
                <div class="mt-1 text-black" style="font-size: 0.6rem; font-weight: bold;">Kebutuhan: ` + item.properties.kebutuhan + `</div>
              </div>
            `
          }

          let div = document.createElement('div')
          div.innerHTML = htmlString
          if (this.$store.getters.isLogin) {
            this.btn = div.querySelector('.mutation-button')
            this.btn.addEventListener('click', () => {
              this.selectMovement({
                teacher: teacher,
                course: course,
                schoolFrom: {
                  sekolah_id: this.selectedSchool.properties.sekolah_id,
                  nama: this.selectedSchool.properties.nama
                },
                schoolTo: {
                  sekolah_id: item.properties.sekolah_id,
                  nama: item.properties.nama
                }
              })
            })
          }
          let popup = window.L.popup({
            closeOnClick: false,
            autoClose: false,
            className: 'custom-popup'
          }).setLatLng(to).setContent(div).openOn(this.map)
          popup.type = type
          this.popups.push(popup)
        })
        this.isMovementAvailable = true
      } else {
        this.isMovementAvailable = false
        if (type === 'one-zone') {
          this.showNoMovementNotification()
        }
      }
    },
    showNoMovementNotification () {
      this.notification = `:(
        <br>
        Tidak ada redistribusi satu zona.
        <br>
        Coba antar zona.`
      this.showNotification = true
      setTimeout(() => {
        this.showNotification = false
      }, 3000)
    },
    schoolPoint (feature, latlng) {
      if (feature.properties.status === 'N') {
        switch (feature.properties.bentuk) {
          case 'SD': return window.L.circleMarker(latlng, {
            stroke: true,
            color: '#000000',
            fillColor: '#DF3A01',
            fillOpacity: 0.9,
            weight: 1,
            radius: 5
          })
          case 'SMP': return window.L.circleMarker(latlng, {
            stroke: true,
            color: '#000000',
            fillColor: '#01A9DB',
            fillOpacity: 0.9,
            weight: 1,
            radius: 6
          })
          case 'SMA': return window.L.circleMarker(latlng, {
            stroke: true,
            color: '#000000',
            fillColor: '#848484',
            fillOpacity: 0.9,
            weight: 1,
            radius: 7
          })
          case 'SMK': return window.L.circleMarker(latlng, {
            stroke: true,
            color: '#000000',
            fillColor: '#196f3d',
            fillOpacity: 0.9,
            weight: 1,
            radius: 7
          })
          case 'PKBM': return window.L.circleMarker(latlng, {
            stroke: true,
            color: '#000000',
            fillColor: '#ffc300',
            fillOpacity: 0.9,
            weight: 1,
            radius: 7
          })
          default: return window.L.circleMarker(latlng, {
            stroke: true,
            color: '#000000',
            fillColor: '#333333',
            fillOpacity: 0.9,
            weight: 1,
            radius: 5
          })
        }
      } else if (feature.properties.status === 'S') {
        switch (feature.properties.bentuk) {
          case 'SD': return window.L.circleMarker(latlng, {
            stroke: true,
            color: '#000000',
            fillColor: '#DF3A01',
            fillOpacity: 0.9,
            weight: 1,
            radius: 5
          })
          case 'SMP': return window.L.circleMarker(latlng, {
            stroke: true,
            color: '#000000',
            fillColor: '#01A9DB',
            fillOpacity: 0.9,
            weight: 1,
            radius: 6
          })
          case 'SMA': return window.L.circleMarker(latlng, {
            stroke: true,
            color: '#000000',
            fillColor: '#848484',
            fillOpacity: 0.9,
            weight: 1,
            radius: 7
          })
          case 'SMK': return window.L.circleMarker(latlng, {
            stroke: true,
            color: '#000000',
            fillColor: '#196f3d',
            fillOpacity: 0.9,
            weight: 1,
            radius: 7
          })
          case 'PKBM': return window.L.circleMarker(latlng, {
            stroke: true,
            color: '#000000',
            fillColor: '#ffc300',
            fillOpacity: 0.9,
            weight: 1,
            radius: 7
          })
          default: return window.L.circleMarker(latlng, {
            stroke: true,
            color: '#000000',
            fillColor: '#333333',
            fillOpacity: 0.9,
            weight: 1,
            radius: 5
          })
        }
      }
    },
    selectMovement (info) {
      this.$store.dispatch(CHANGE_MUTATION_INFO, info)
      this.$store.dispatch(TOGGLE_MODAL_MUTATION, true)
      // console.log('info', info)
    },
    async search (keywords) {
      try {
        this.isSearching = true
        this.searchResults = []
        let response = await fetch(process.env.VUE_APP_API_URL + '/api/simrasio/search/' + encodeURI(keywords))
        this.isSearching = false
        let json = await response.json()
        if (Array.isArray(json) && json.length) {
          this.isSearchResultAvailable = true
          this.searchResults = json
        } else {
          this.isSearchResultAvailable = false
        }
      } catch (err) {
        this.isSearchResultAvailable = false
      }
    },
    async openSchool (school) {
      let properties = {
        zonasi_id: school.properties.zonasi_id
      }

      this.toggleSelection(CHANGE_SELECTED_PROVINCE, school.province.properties)
      this.toggleSelection(CHANGE_SELECTED_ZONE, properties)
      this.fetchAllDistricts(() => {
        this.showZoneArea(() => {
          this.onSchoolClicked(school, () => {
            this.updateSelectedCircle(school.geometry.coordinates[1], school.geometry.coordinates[0], school.properties.bentuk)
          })
        })
      })

      try {
        let response = await fetch(process.env.VUE_APP_API_URL + '/api/districtsByZone/' + school.properties.zonasi_id)
        let json = await response.json()
        if (json.status) {
          this.$store.dispatch(CHANGE_SELECTED_DISTRICT, json.districts[0].properties)
        }
      } catch (err) {
        // console.log(err)
      }
    },
    async openPublicZone (zone) {
      let provinceProperties = {
        kode_wilayah: zone.properties.kode_wilayah,
        nama: zone.properties.nama_provinsi
      }

      this.toggleSelection(CHANGE_SELECTED_PROVINCE, provinceProperties)
      this.toggleSelection(CHANGE_SELECTED_ZONE, zone.properties)
      this.fetchAllDistricts(() => {
        this.showZoneArea(() => {
          this.toggleModal(TOGGLE_MODAL_ZONE, true)
        })
      })

      try {
        let response = await fetch(process.env.VUE_APP_API_URL + '/api/districtsByZone/' + zone.properties.zonasi_id)
        let json = await response.json()
        if (json.status) {
          this.$store.dispatch(CHANGE_SELECTED_DISTRICT, json.districts[0].properties)
        }
      } catch (err) {
        // console.log(err)
      }
    },
    showAllNegeri () {
      this.isShowAllNegeri = !this.isShowAllNegeri
      if (this.isShowAllNegeri) {
        this.isShowSDNegeri = true
        this.isShowSMPNegeri = true
        this.isShowSMANegeri = true
        this.isShowSMKNegeri = true
        this.isShowPKBMNegeri = true
        this.isShowOthersNegeri = true
      } else {
        this.isShowSDNegeri = false
        this.isShowSMPNegeri = false
        this.isShowSMANegeri = false
        this.isShowSMKNegeri = false
        this.isShowPKBMNegeri = false
        this.isShowOthersNegeri = false
      }
    },
    showAllSwasta () {
      this.isShowAllSwasta = !this.isShowAllSwasta
      if (this.isShowAllSwasta) {
        this.isShowSDSwasta = true
        this.isShowSMPSwasta = true
        this.isShowSMASwasta = true
        this.isShowSMKSwasta = true
        this.isShowPKBMSwasta = true
        this.isShowOthersSwasta = true
      } else {
        this.isShowSDSwasta = false
        this.isShowSMPSwasta = false
        this.isShowSMASwasta = false
        this.isShowSMKSwasta = false
        this.isShowPKBMSwasta = false
        this.isShowOthersSwasta = false
      }
    },
    updateNegeriAllStatus (level) {
      this['isShow' + level + 'Negeri'] = !this['isShow' + level + 'Negeri']
      if (this.isShowSDNegeri === true &&
        this.isShowSMPNegeri === true &&
        this.isShowSMANegeri === true &&
        this.isShowSMKNegeri === true &&
        this.isShowPKBMNegeri === true &&
        this.isShowOthersNegeri === true) {
        this.isShowAllNegeri = true
      } else {
        this.isShowAllNegeri = false
      }
    },
    updateSwastaAllStatus (level) {
      this['isShow' + level + 'Swasta'] = !this['isShow' + level + 'Swasta']
      if (this.isShowSDSwasta === true &&
        this.isShowSMPSwasta === true &&
        this.isShowSMASwasta === true &&
        this.isShowSMKSwasta === true &&
        this.isShowPKBMSwasta === true &&
        this.isShowOthersSwasta === true) {
        this.isShowAllSwasta = true
      } else {
        this.isShowAllSwasta = false
      }
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.slide-right-enter-active {
  transition: all .2s ease;
}
.slide-right-leave-active {
  transition: all .2s ease;
}
.slide-right-enter, .slide-right-leave-to {
  transform: translateX(100%);
}

.slide-top-enter-active, .slide-top-leave-active {
  transition: opacity .5s;
}
.slide-top-enter, .slide-top-leave-to {
  opacity: 0;
}
.slide-top-enter-active {
  transition: all .2s ease;
}
.slide-top-leave-active {
  transition: all .2s ease;
}
.slide-top-enter, .slide-top-leave-to {
  transform: translateY(-100%);
}
</style>
